<template>
<div class="card-body">
  <CardLayout  @onHrTree="onHrTree">
    <div class="search-wrap">
      <!--    <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>-->
      <el-button size="mini" type="primary" @click="editUser()">添加</el-button>
    </div>

    <div class="table-wrap">
      <el-table v-loading="loading" class="chat-table" :data="tableData">
        <el-table-column prop="id" label="ID" align="left" width="50"></el-table-column>
        <el-table-column prop="department_name" label="部门专用" align="center" width="320"></el-table-column>
        <el-table-column prop="name" label="名称" align="center"></el-table-column>
        <el-table-column prop="is_internal" label="归属类型" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.is_internal?'success':'info'">{{scope.row.is_internal?'内部':'外部'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="path" label="背景" align="center">
          <template slot-scope="scope">
            <el-popover
              placement="right"
              width="450"
              trigger="hover">
              <el-image
                style="width: 400px; height: 200px"
                :src="hostUrl(scope.row.path)"
                fit="fill"></el-image>
              <el-image
                slot="reference"
                style="width: 100px; height: 50px"
                :src="hostUrl(scope.row.path)"
                fit="cover"></el-image>
            </el-popover>

          </template>
        </el-table-column>
        <el-table-column prop="color" label="字体颜色" align="center">
          <template slot-scope="scope">
            <el-color-picker v-model="scope.row.color" @change="setFormItem(scope.row)"></el-color-picker>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status" @change="setFormItem(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="editUser(scope.row)">修改</el-button>
            <!--          <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteUser(scope.row)">删除</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-wrap">
      <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page="page" @current-change="pageChange"></el-pagination>
    </div>
  </CardLayout>


  <!-- 修改窗口 -->
  <el-dialog title="背景编辑" :visible.sync="dialogVisible" width="600px">
    <el-form :model="form" :rules="rules" ref="form" label-width="100px" size="mini" style="margin-right: 50px;">
      <el-form-item label="名称" prop="name">
        <el-input type="text" v-model="form.name" placeholder="输入名称"></el-input>
      </el-form-item>
      <el-form-item label="归属类型" prop="is_internal">
        <el-select
          v-model="form.is_internal"
          placeholder="选择类型">
          <el-option
            v-for="item in [{id:0,name:'其他'},{id:1,name:'中奥'}]"
            :key="item.id"
            :label="item.name"
            :value="(item.id*1)">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属组织" prop="group_id">
        <!--            <SelectDepartment v-model="form.department_name" @change="form.department_id=$event.id;" />-->
        <SelectDepartmentCascader v-if="dialogVisible" v-model="form.department_name" @change="form.department_ids=$event.ancestor_id;" />
      </el-form-item>
      <el-form-item label="背景图" prop="name">
        <UploadFileCard :list="form_imgs" :host-url="host_url" :upload-url="host_url+'/admin/CardBackground/uploadFile'" @success="UploadFileFJSuccess"/>
        <p style="color: #F56C6C;">请上传背景图尺寸为：680*360 px</p>
      </el-form-item>
      <el-form-item label="字体颜色" prop="name">
        <el-color-picker v-model="form.color"></el-color-picker>
      </el-form-item>
      <el-form-item label="状态" prop="name">
        <el-switch v-model="form.status" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitForm('form')" :loading="formLoading">确 定</el-button>
    </div>
  </el-dialog>

</div>
</template>

<script>

  import { Loading } from 'element-ui';
  import { User, UserGroup } from './common.js'
  import xhHelp from "./xhHelp";
  import UploadFileCard from "./components/UploadFileCard";
  import CardLayout from "./components/CardLayout";
  import SelectDepartmentCascader from "./components/SelectDepartmentCascader";

export default {
  name: "CardBackground",
  components: {SelectDepartmentCascader, CardLayout, UploadFileCard},
  data () {
    return {
      is_internal: '',
      group_id: '',
      keyword: '',
      loading: false,
      tableData: [],
      groupList: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      formLoading: false,
      form: {
        id:'',
        name:"",
        is_internal:0,
        path:'',
        color:'',
        status:true,
        department_name:"",
        department_ids:""
      },
      form_imgs:null,
      rules: {
      },
      articleTableData:[],
      articleKeyword:"",
      hostUrl:xhHelp.hostUrl,
      host_url:xhHelp.host_url,
      // config_list:[]
    }
  },
  created() {

    UserGroup.getList(res => {
      if(res.code == 0) {
        this.groupList = res.data.data
      }
    })

    // this.getConfigList()

    this.getList()

  },
  methods: {
    search() {
      this.page = 1
      this.getList()
    },
    getList() {
      // User.getList({keyword: this.keyword, page: this.page, page_size: this.pageSize}, res => {
      //   if(res.code == 0) {
      //     this.total = res.data.total
      //     this.tableData = res.data.data
      //   }
      // })
      xhHelp.get("CardBackground/getList",{
        keyword: this.keyword,
        department_id:this.department_id,
        page: this.page,
        page_size: this.pageSize
      },res => {
        if(res.code == 0) {
          this.total = res.data.total
          this.tableData = res.data.data
        }
      })

    },
    // getConfigList(){
    //   const that=this;
    //   xhHelp.get("CardBackground/getConfigList",{},res => {
    //     if(res.code) {
    //       that.config_list = res.data
    //     }
    //   })
    // },
    pageChange(i) {
      this.page = i
      this.getList()
    },
    editUser(item=null) {

      let data = {}

      if(item){
        for(let k in this.form) {
          data[k] = item[k]
        }
        this.form_imgs=[{url:this.hostUrl(data.path)}]
        this.form = data
      }else {
        this.form_imgs=[]
        this.form = {
          id:'',
          name:"",
          is_internal:0,
          path:'',
          color:'',
          status:true,
          department_name:"",
          department_ids:""
        }
      }


      this.dialogVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.formLoading = true
          let data = Object.assign({}, this.form)
          xhHelp.post("CardBackground/update",data,res => {
            this.$message({type: res.code == 0 ? 'success': 'error', message: res.msg})
            if(res.code == 0) {
              this.dialogVisible = false
              this.getList()
            }
            this.formLoading = false
          })

        } else {
          return false;
        }
      });
    },
    setFormItem(item){
      let data = Object.assign({}, item)
      xhHelp.post("CardBackground/update",data,res => {
        this.$message({type: res.code == 0 ? 'success': 'error', message: res.msg})
        if(res.code == 0) {
          this.getList()
        }
      })
    },
    deleteUser(item) {

      this.$confirm('此操作将删除该会员['+item.phone+'], 是否继续?', '提示', {type: 'warning'}).then(() => {
        User.delete(item.id, res => {
          this.$message({type: res.code == 0 ? 'success': 'error', message: res.msg})
          if(res.code == 0) {
            this.getList()
          }
        })
      })

    },
    UploadFileFJSuccess(file){
      if(file){
        this.form_imgs=[{url:this.hostUrl(file)}]
      }else {
        this.form_imgs=null
      }

      this.form.path=file;
    },
    onHrTree(e){
      const that=this;
      that.department_id=e.id;
      that.search();
    }
  }
}
</script>
<style lang="scss" scoped>

  @import './common.scss';

</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Card/CardBackground.vue